<template>
    <div class="app-footer py-5" :style="{backgroundImage: 'linear-gradient(rgba(0, 65, 107, 0.68), rgba(0, 65, 107, 0.68)), url('+ footerImage +')'}">
        <div class="container">
            <div class="footer-logo">
                <img :src="footerLogo" alt="M&O Law Consult">
            </div>

            <div class="footer-nav text-center mt-5">
                <ul class="list-inline text-uppercase">
                    <li class="list-inline-item px-4">
                        <router-link to="/">Home</router-link>
                    </li>

                    <li class="list-inline-item px-4">
                        <router-link to="/about-us">ABOUT US</router-link>
                    </li>

                    <li class="list-inline-item px-4">
                        <router-link to="/practice-areas">PRACTICE AREAS</router-link>
                    </li>

                    <li class="list-inline-item px-4">
                        <router-link to="/articles">ARTICLES</router-link>
                    </li>

                    <li class="list-inline-item px-4">
                        <router-link to="/careers">CAREERS</router-link>
                    </li>

                    <li class="list-inline-item px-4">
                        <router-link to="/contact-us">CONTACT US</router-link>
                    </li>

                    <li class="list-inline-item px-4">
                        <router-link to="/sitemap">SITEMAP</router-link>
                    </li>

                </ul>
            </div>

            <div class="footer-social text-center mt-4">
                <ul class="list-inline">
                    <li class="list-inline-item px-2">
                        <a 
                            href="https://www.linkedin.com/company/molawconsult/?viewAsMember=true/" 
                            target="_blank"
                        >
                            <i class="ti-linkedin"></i>
                        </a>
                    </li>
                     <li class="list-inline-item px-2">
                        <a 
                            href="https://www.facebook.com/molawconsult/" 
                            target="_blank"
                        >
                            <i class="ti-facebook"></i>
                        </a>
                    </li>
                    <!-- <li class="list-inline-item px-2">
                        <a href="#!" target="_blank"><i class="ti-twitter-alt"></i></a>
                    </li>
                    <li class="list-inline-item px-2">
                        <a href="#!" target="_blank"><i class="ti-instagram"></i></a>
                    </li> -->
                </ul>
            </div>
            

            <div class="text-center">
                <p>&copy; M&O Law Consult {{ copyrightYear }}</p>
                <p>
                    Designed and Developed by
                    <a href="http://www.tribalhousestudios.com" target="_blank">
                        Tribal House Studios
                    </a>
                </p>
            </div>

        </div>
    </div>
</template>

<script>
let footerImage = require("@/assets/img/footer/footer.jpg");
let footerLogo = require("@/assets/img/footer/footer-logo.png");
let date = new Date();

export default {
    name: "Footer",
    data() {
        return {
            footerImage: footerImage,
            footerLogo: footerLogo,
            copyrightYear: date.getFullYear()
        };
    }
};
</script>





// WEBPACK FOOTER //
// src/components/frontend/templates/Footer.vue